<i18n src="@/lang/actions.json" />

<template>
  <el-main>
    <header-actions>
      <template slot="left-side">
        <el-input
          size="small"
          spa-action="find"
          clearable
          v-model="$store.state.shared_amocrm_licenses_cost_list.filter_string"
        />
      </template>
      <template slot="button-group">
        <el-button
          size="small"
          :disabled="editMode"
          @click="handleAddNew"
          v-t="'actions.add_new'"
        />
      </template>
    </header-actions>
    <br />
    <el-table :data="licenses" :border="false">
      <el-table-column
        v-for="(v, k) in schema"
        :key="k"
        :label="v.label || k"
        v-bind="v.props"
        :prop="v.field || k"
      />
      <el-table-column :width="110">
        <template slot-scope="scope">
          <el-button-group>
            <el-button
              size="small"
              icon="el-icon-edit"
              style="color: navy"
              @click="handleEdit(scope)"
            />
            <el-button
              size="small"
              icon="el-icon-delete"
              style="color: red"
              @click="handleDelete(scope)"
            />
          </el-button-group>
        </template>
      </el-table-column>
    </el-table>
    <edit-amo-licenses
      v-if="curEdit"
      :visible="editMode"
      :value="curEdit"
      @save="handleSave"
      @cancel="handleCancel"
    />
  </el-main>
</template>

<script>
import { mapGetters, mapActions, mapMutations } from "vuex";
import HeaderActions from "../_snippets/header_actions/header_actions";
import SharedAmocrmLicensesCost from "../../store/classes/SharedAmocrmLicensesCost";
import EditAmoLicenses from "./elements/edit_amo_licenses";

export default {
  name: "amoLicensesList",
  components: { EditAmoLicenses, HeaderActions },
  data() {
    return {
      schema: SharedAmocrmLicensesCost.schema,
      editMode: false,
      curEditIndex: null,
      curEdit: null
    };
  },
  created() {
    this.getData();
  },
  beforeRouteLeave(to, from, next) {
    this.resetState();
    next();
  },
  watch: {
    editMode(v) {
      v || (this.curEdit = null);
    }
  },
  methods: {
    ...mapMutations("shared_amocrm_licenses_cost_list", [
      "resetState",
      "addFirst"
    ]),
    ...mapActions("shared_amocrm_licenses_cost_list", ["getData"]),
    handleAddNew() {
      this.addFirst();
      this.curEditIndex = 0;
      this.curEdit = this.licenses[this.curEditIndex];
      this.editMode = true;
    },
    handleEdit(scope) {
      this.curEditIndex = scope.$index;
      this.curEdit = this.licenses[this.curEditIndex];
      this.editMode = true;
    },
    handleDelete(scope) {
      scope.row
        .delete()
        .then(res => {
          this.licenses.splice(scope.$index, 1);
        })
        .catch(() => {
          return "scipped";
        });
    },
    handleSave(model) {
      let uuid = Object.assign(this.curEdit, model).uuid;
      this.licenses[this.curEditIndex].save();
      this.editMode = !!(this.curEditIndex = this.curEdit = null);
      if (!uuid) {
        this.licenses.push(this.licenses.shift());
      }
    },
    handleCancel() {
      if (!this.curEdit.uuid) {
        this.licenses.shift();
      }
      this.curEdit = this.curEditIndex = this.editMode = false;
    }
  },
  computed: {
    ...mapGetters("shared_amocrm_licenses_cost_list", ["licenses"])
  }
};
</script>

<style scoped></style>
